import { render, staticRenderFns } from "./CusTypeTimeConfiguration.vue?vue&type=template&id=62fa1c3c&scoped=true&"
import script from "./CusTypeTimeConfiguration.vue?vue&type=script&lang=js&"
export * from "./CusTypeTimeConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./CusTypeTimeConfiguration.vue?vue&type=style&index=0&id=62fa1c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62fa1c3c",
  null
  
)

export default component.exports